import ParagraphWriter from '../../../src/components/content-ai-tools/ParagraphWriter';
import ToolsStyleWrapper from '../../../src/components/content-ai-tools/components/ToolsStyleWrapper';

const PublicDiscoveryKeywordsWrapped = () => {
  return <ToolsStyleWrapper component={ParagraphWriter} />;
};

export default PublicDiscoveryKeywordsWrapped;
